import { useNavigate } from "react-router-dom";
import { CreditCard } from "lucide-react";

const BuyNowButton = ({ book }) => {
  const navigate = useNavigate();

  const handleBuyNow = () => {
    if (!book) return;

    // Prepare a cart item array with quantity 1
    const cartItems = [
      {
        id: book.id,
        name: book.booknameinenglish,
        price: book.price, // ✅ make sure discounted price is passed here
        quantity: 1,
        image: book.image,
      },
    ];

    const total = book.price * 1; // quantity is 1
    const delivery = 0; // optional, can pass delivery charge if needed

    navigate("/pos/checkout", {
      state: { cartItems, total, delivery },
    });
  };

  return (
    <button
      onClick={handleBuyNow}
      className="flex-1 flex items-center justify-center gap-1 rounded-lg bg-green-600 text-white py-2 text-sm font-semibold hover:bg-green-700 transition"
    >
      <CreditCard size={16} />
      Buy Now
    </button>
  );
};

export default BuyNowButton;
